/**
 * Resolve the API base URL for the Strata backend.
 * Works in both Vite (frontend) and Node.js (backend) environments.
 */
export function getStrataApiBaseUrl(): string {
  // Try Vite environment variables (frontend)
  const viteEnvBaseUrl =
    typeof import.meta !== 'undefined' && import.meta.env && import.meta.env.VITE_API_BASE_URL

  if (typeof viteEnvBaseUrl === 'string' && viteEnvBaseUrl.length > 0) {
    return viteEnvBaseUrl
  }

  // Try Node.js environment variables (backend)
  const nodeEnvBaseUrl =
    typeof process !== 'undefined' && process.env && process.env.VITE_API_BASE_URL

  if (typeof nodeEnvBaseUrl === 'string' && nodeEnvBaseUrl.length > 0) {
    return nodeEnvBaseUrl
  }

  // Determine environment mode
  const mode: string =
    (typeof import.meta !== 'undefined' && import.meta.env && import.meta.env.VITE_ENVIRONMENT) ||
    (typeof process !== 'undefined' && process.env && process.env.VITE_ENVIRONMENT) ||
    'development'

  const isProd: boolean = mode === 'production'

  const fallback = isProd
    ? 'https://strata.saveonenergy.cloud/strata-api'
    : 'https://strata.staging.saveonenergy.cloud/strata-api'

  return fallback
}
